import { render, staticRenderFns } from "./tp3New.vue?vue&type=template&id=29f2ff0c"
import script from "./tp3New.vue?vue&type=script&lang=js"
export * from "./tp3New.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports